import React from 'react'
import AdmSearchIncome from '../../components/AdminTabs/AdminSearchIncome/AdmSearchIncome'

const SearchIncome = () => {
  return (
    <div><AdmSearchIncome/></div>
  )
}

export default SearchIncome